/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create and rename a condition. Its tree is written through the tree endpoint.
 * @export
 * @interface ConditionWriteRequest
 */
export interface ConditionWriteRequest {
    /**
     * 
     * @type {string}
     * @memberof ConditionWriteRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ConditionWriteRequest
     */
    workflow: string;
}

/**
 * Check if a given object implements the ConditionWriteRequest interface.
 */
export function instanceOfConditionWriteRequest(value: object): value is ConditionWriteRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('workflow' in value) || value['workflow'] === undefined) return false;
    return true;
}

export function ConditionWriteRequestFromJSON(json: any): ConditionWriteRequest {
    return ConditionWriteRequestFromJSONTyped(json, false);
}

export function ConditionWriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConditionWriteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'workflow': json['workflow'],
    };
}

export function ConditionWriteRequestToJSON(json: any): ConditionWriteRequest {
    return ConditionWriteRequestToJSONTyped(json, false);
}

export function ConditionWriteRequestToJSONTyped(value?: ConditionWriteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'workflow': value['workflow'],
    };
}

